import axios from "axios";


export const fetchAcces = async ({
                                       that,
                                       params
                                   }) => {
    var form = new FormData();
    Object.keys(params).forEach(key => {
        form.append(key,params[key]);
    })
    return await axios.post(that.BASE_URL+'/groupeutilisateur/fetchacces',form);
}